import * as React from 'react';
import { Select, useFieldState, useField } from 'informedv4';
import { inputClasses } from '../validation/ValidationClasses';
import { omit } from "lodash";

type DropdownProps = React.ComponentProps<typeof Select> & {
    name: string;
    className?: string;
};

export const Dropdown = ({ name, className, disabled, ...props }: DropdownProps) => {
    const { error, showError } = useFieldState(name);

    const {
        validate,
        validateOn,
        initialValue,
        relevant,
        onNativeChange,
        required: requiredRaw,
        onChange,
    } = props as any;


    const domProps = omit(props, [
        'validate',
        'validateOn',
        'initialValue',
        'relevant',
        'onNativeChange',
        'required',
        'value',
        'defaultValue',
        'onChange',
        'onBlur',
        'type',
    ]);

    const required =
        typeof requiredRaw === 'string'
            ? requiredRaw !== 'false' && requiredRaw !== ''
            : !!requiredRaw;

    const { fieldApi, fieldState, ref, userProps } = useField({
        name,
        type: 'select',
        validate,
        validateOn,
        initialValue,
        required,
        relevant,
        onNativeChange
    });

    return (
        <>
            <select
                {...userProps}
                disabled={disabled}
                name={name}
                ref={ref}
                className={`${inputClasses(error as string)} ${className ?? ''}`.trim()}
                {...domProps as any}
                required={required}
                value={String(fieldState.value ?? '')}
                onChange={(e) => {
                    fieldApi.setValue(e.currentTarget.value);
                    if (onChange) {
                        onChange(e);
                    }
                }}
                onBlur={() => fieldApi.setTouched(true)}
            >{props.children}</select>
            {showError && error ? (
                <span className="field-validation-error">{error as string}</span>
            ) : null}
        </>
    );
};
